const forms = {
  state: {
    equip: null,
    equipDID: null,
    equipRegister: null,
    equipRegisterCounter: 0
  },
  mutations: {
    changeEquipRegister(state, payload) {
      state.equipRegister = payload;
    },
    changeEquipRegisterCounter(state, payload) {
      state.equipRegisterCounter = payload;
    },
    changeEquip(state, payload) {
      state.equip = payload;
    },
    changeEquipDID(state, payload) {
      state.equipDID = payload;
    }
  },
  actions: {
    changeEquipRegister({ commit }, payload) {
      commit("changeEquipRegister", payload);
    },
    changeEquipRegisterCounter({ commit }, payload) {
      commit("changeEquipRegisterCounter", payload);
    },
    changeEquip({ commit }, payload) {
      // commit to store
      commit("changeEquip", payload);
    },
    changeEquipDID({ commit }, payload) {
      // commit to store
      commit("changeEquipDID", payload);
    }
  },
  getters: {
    getEquipRegister: state => {
      return state.equipRegister;
    },
    getEquipRegisterCounter: state => {
      return state.equipRegisterCounter;
    },
    getEquip: state => {
      return state.equip;
    },
    getEquipDID: state => {
      return state.equipDID;
    }
  }
};
// eslint-disable-next-line
export default forms;
